import * as React from "react";
import { connect } from "react-redux";
import { bindActionCreators,Dispatch } from "redux";
import classNames from "classnames";
import { Dimmer } from "semantic-ui-react";
import Table from "../../../components/Table/Table";
import { EditActions, editActions } from "../../../actions/editActions";
import {
  isEditActiveSelector,
  editedObjectIdSelector,
  editedObjectIdentifierSelector
} from "../../../reducers/editReducer";
import _ from "lodash";
import EditEnum from "../../Editing/EditEnum";
import { mainActions } from "../../../actions/mainActions";
import { Filter } from "../../../components/Table/Migration/LegacyTypes";

type StateProps = {
  pdApi: State.PdApi;
  columns: State.ColumnMap;
  mainState: State.Main;
  editedObjectId: number | undefined;
  isEditActive: boolean;
  objectIdentifier: string;
};

type DispatchProps = {
  editActions: typeof editActions;
  mainActions: typeof mainActions;
};

type OwnProps = {
  subMenuRoute: State.AnySubMenu | State.AnyChildItem;
  toggleModal: () => void;
  dataFieldName: keyof State.PdApi | null;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  editor?: any;
  setColumnFilters: (subMenuRoute: State.AnySubMenu | State.AnyChildItem, columnFilter: Filter[]) => void;
};

// Props of the component
export type EnumTableProps = StateProps & DispatchProps & OwnProps;

type EnumTableState = {
  isModalOpen: boolean;
};

export class EnumTable extends React.Component<EnumTableProps, EnumTableState> {
  state = {
    isModalOpen: false
  };
  componentDidUpdate(prevProps: EnumTableProps): void {
    if (prevProps.subMenuRoute !== this.props.subMenuRoute) {
      this.props.mainActions.setLastEditedObjectId(undefined);
    }
  }

  componentDidMount(): void {
    // make throttle function
    this.handleFilterChangeDebounced = _.debounce(this.handleFilterChangeDebounced, 500);
  }

  private handleFilterChangeDebounced = (changedFilters: Filter[]) => {
    this.props.setColumnFilters(this.props.subMenuRoute, changedFilters);
  };
    componentWillUnmount(): void {
    this.props.mainActions.setLastEditedObjectId(undefined);
  }

  render(): JSX.Element {
    const { columns, pdApi, mainState, isEditActive, dataFieldName, subMenuRoute } = this.props;
    if (!dataFieldName) {
      return <div>Error : missing dataFieldName</div>;
    }
    let selectedData: Api.AnyItem[];
    if (typeof pdApi[dataFieldName] === typeof Array) {
      selectedData = pdApi[dataFieldName] as Api.AnyItem[];
    } else {
      selectedData = _.values(pdApi[dataFieldName]);
    }

    const { editSize, pageSize, isShortenTextEnabled } = mainState;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const rows: any[] = selectedData;
    const editor = this.props.editor || EditEnum;
    const selectedColumns: State.Column[] = columns[subMenuRoute as keyof State.ColumnMap];

    const startingPage = mainState.lastEditedObjectId
      ? (rows.findIndex(enumeration => this.isEnumerationSelected(enumeration)) / // tslint:disable-line: no-bitwise
        mainState.pageSize) >>
      0
      : 0;
    return (
      <div className="flex-1">
        <div className={`flex-1 ${dataFieldName === "electrifications" ? "ElectrificationTable" : "IOEventEnumTable"}`}>
          <Table
            key={this.props.subMenuRoute} // this forces re-render when view changes to reset page to 0
            startingPage={startingPage}
            rows={rows}
            columns={selectedColumns}
            isHidingTextActive={isShortenTextEnabled}
            handleRowSelection={this.props.editActions.select}
            isRowSelected={this.isEnumerationSelected}
            pageSize={pageSize}
            handleFilterChange={this.handleFilterChangeDebounced}            
          />
        </div>
        {isEditActive && (
          <Dimmer active={true} page={true}>
            <div
              className={classNames("edit-view", {
                "xlg-edit-view": dataFieldName === "ioBasicDataTypes" || dataFieldName === "messageTypes",
                "xs-edit-view": dataFieldName === "iodataSections"
              })}
              style={{ flex: editSize , width : editSize == 0.3 ? "500px" : "1000px" }}
            >
              {React.createElement(editor, {
                ...this.props,
                toggleModal: this.props.toggleModal,
                dataFieldName: dataFieldName
              })}
            </div>
          </Dimmer>
        )}
      </div>
    );
  }

  private isEnumerationSelected = (enumeration: Api.AnyItem): boolean => {
    const editedObjectId = this.props.editedObjectId ?? this.props.mainState.lastEditedObjectId;
    // Enumerations can have different fields used as id, we check if any of them matches editedID
    if (editedObjectId !== undefined) {
      if (
        enumeration.enumValue === editedObjectId ||
        enumeration.value === editedObjectId ||
        enumeration.id === editedObjectId ||
        enumeration.boardTypeId === editedObjectId
      ) {
        return true;
      }
    }
    return false;
  };
}

const mapStateToProps = (state: State.Root, ownProps: OwnProps) => ({
  columns: state.columns,
  pdApi: state.pdApi,
  mainState: state.main,
  isEditActive: isEditActiveSelector(state.editView),
  editedObjectId: editedObjectIdSelector(state.editView),
  objectIdentifier: editedObjectIdentifierSelector(state.editView, ownProps.subMenuRoute)
});

const mapDispatchToProps = (dispatch: Dispatch<EditActions>) => ({
  editActions: bindActionCreators({ ...editActions }, dispatch),
  mainActions: bindActionCreators({ ...mainActions }, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(EnumTable);
